import { Map } from 'immutable';

function findLastElementInImmutableChain(map) {
  let current = map;
  while (Map.isMap(current)) {
    const firstEntry = current.entrySeq().first();
    // Check if there's an entry at all
    if (!firstEntry) {
      return null; // Empty map, no entries
    }

    const [key, value] = firstEntry; // Now safe to destructure
    if (Map.isMap(value) && value.isEmpty()) {
      return key; // Final element in the chain
    }
    current = value;
  }
  return null; // If input is not a valid chain
}

export { findLastElementInImmutableChain };
